import React from 'react';

const PageNotFound = () => (
  <div>
    <h1>Page not found</h1>
  </div>
);

export default PageNotFound;
